import React from "react";

const Features = () => {
  return (
    <section id="features" className=" text-black">
      <div className="mx-auto max-w-screen-xl px-4 py-8 sm:py-12 sm:px-6 lg:py-16 lg:px-8">
        <div className="mx-auto max-w-lg text-center">
          <h2 className="text-3xl font-bold sm:text-4xl">Platform features</h2>

          <p className="mt-4 text-black">
            The platform offers numerous features designed to enhance the
            trustworthiness, value, and manageability of digital NFT certificate
            issuance. Here are some of the key platform features -
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">Decentralize</h2>

            <p className="mt-1 text-sm text-black">
              The platform is built on the Ethereum public blockchain, ensuring
              its reliance on a decentralized network to eliminate any potential
              single points of vulnerability, which could otherwise result in
              untrustworthiness, server failures or fraudulent activities.
            </p>
          </a>

          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">Transparent</h2>

            <p className="mt-1 text-sm text-black">
              Public profiles of earners, issuer profiles, and ownership records
              of issued NFTs/Certificates are maintained in a publicly
              accessible and fully transparent manner, facilitating the
              effortless sharing of certificate ownership and earner profiles.
            </p>
          </a>

          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">
              Secure - Ownership
            </h2>

            <p className="mt-1 text-sm text-black">
              Blockchain offers an immutable ledger that remains unaltered and
              unmodifiable without the execution of a transaction. Only the
              rightful owners and authorized organization issuers have the
              capability to carry out their designated actions using their
              wallet accounts.
            </p>
          </a>

          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">Verifiable</h2>

            <p className="mt-1 text-sm text-black">
              The issuance of certificates and the ownership of these issued
              certificates are openly accessible and easily confirmable by
              anyone via the public network.
            </p>
          </a>

          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">
              Soulbound - Non transferable NFTs
            </h2>

            <p className="mt-1 text-sm text-black">
              By default, NFTs (tokens) can be transferred to another wallet
              account, but Soulbound NFTs are non-transferrable, fulfilling
              their role as certificates. Once a certificate is assigned to an
              account, it becomes bound to that wallet address and cannot be
              moved to a different one.
            </p>
          </a>

          <a
            className="block rounded-xl border border-red-500/10 p-8 shadow-md transition hover:border-pink-500/10 hover:shadow-pink-500/10 hover:scale-110"
            // href="/services/digital-campaigns"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-orange-700"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>

            <h2 className="mt-4 text-xl font-bold text-black">Easy to use</h2>

            <p className="mt-1 text-sm text-black">
              The SiddhiCred platform is designed with user-friendliness as a
              top priority. User just needs to connect their wallet and approve
              / authorize the actions (transactions).
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;
